import { useEffect, useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getClientId } from "./clientId";
import { fetchHandleWatch, fetchAlertSettings } from "./api";

const SEEN_KEY = "alphaapeing_handle_seen";

export const getHandleSeen = () => {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]")); } catch { return new Set(); }
};

export const markHandlesSeen = (mints) => {
  localStorage.setItem(SEEN_KEY, JSON.stringify(mints || []));
  window.dispatchEvent(new Event("handle-seen-updated"));
};

export const useHandleAlerts = () => {
  const clientId = getClientId();
  const settingsQ = useQuery({ queryKey: ["alertSettings", clientId], queryFn: () => fetchAlertSettings(clientId) });
  const minScore = settingsQ.data?.handleMinScore ?? 0;

  const q = useQuery({
    queryKey: ["handleWatch", clientId, false, false, minScore],
    queryFn: () => fetchHandleWatch(clientId, false, false, minScore),
    refetchInterval: 60000,
  });

  const mints = useMemo(() => {
    const out = [];
    for (const h of q.data?.handles || []) {
      for (const m of h.matches || []) if (m.mint) out.push(m.mint);
    }
    return out;
  }, [q.data]);

  const [seen, setSeen] = useState(getHandleSeen);
  useEffect(() => {
    const h = () => setSeen(getHandleSeen());
    window.addEventListener("handle-seen-updated", h);
    return () => window.removeEventListener("handle-seen-updated", h);
  }, []);

  const newCount = mints.filter((m) => !seen.has(m)).length;
  return { newCount, mints };
};
